// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3MRYx","content":"LayoutSettings_content__eEvzB"};